"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tag = require("@citrus/tag");
var _card = require("@citrus/card");
var _button = require("@citrus/button");
var _icon = require("@citrus/icon");
var _reactQuestion = _interopRequireDefault(require("@pcty/react-question"));
var _questionBuilder = require("@pcty/question-builder");
require("./index.css");
var _Icon;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionBuilderQuestionBankPreview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilderQuestionBankPreview, _Component);
  var _super = _createSuper(PctyQuestionBuilderQuestionBankPreview);
  function PctyQuestionBuilderQuestionBankPreview(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilderQuestionBankPreview);
    _this = _super.call(this, props);
    _this.onDeleteQuestion = _this.onDeleteQuestion.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilderQuestionBankPreview, [{
    key: "onDeleteQuestion",
    value: function onDeleteQuestion(deletedItemId) {
      var selectedQbItemIds = (0, _toConsumableArray2.default)(this.props.selectedQbItemIds);

      // find and remove the item
      var srcIndex = selectedQbItemIds.indexOf(deletedItemId);
      selectedQbItemIds.splice(srcIndex, 1);
      this.props.onQuestionsChange(selectedQbItemIds);
    }
  }, {
    key: "renderQuestion",
    value: function renderQuestion(question, number) {
      if (!question) return null;
      var view = null;
      var defaultFunction = function defaultFunction() {};
      var response = null;
      switch (question.typeId) {
        case _questionBuilder.QUESTION_TYPE.multipleChoice:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.MultipleChoice, (0, _extends2.default)({}, question, {
            response: response || [],
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
        case _questionBuilder.QUESTION_TYPE.dropdownList:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.DropdownList, (0, _extends2.default)({}, question, {
            placeholder: question.questionPlaceholder || "Select...",
            response: response || [],
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
        case _questionBuilder.QUESTION_TYPE.checkbox:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.Checkbox, (0, _extends2.default)({}, question, {
            response: response || [],
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
        case _questionBuilder.QUESTION_TYPE.starRating:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.StarRating, (0, _extends2.default)({}, question, {
            response: response || 0,
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            onComment: function onComment(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
        case _questionBuilder.QUESTION_TYPE.ratingScale:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.RatingScale, (0, _extends2.default)({}, question, {
            response: response || 0,
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            onComment: function onComment(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
        case _questionBuilder.QUESTION_TYPE.stackRank:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.StackRank, (0, _extends2.default)({}, question, {
            response: response || [],
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
        case _questionBuilder.QUESTION_TYPE.multipleText:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.MultipleText, (0, _extends2.default)({}, question, {
            response: response || '',
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
        case _questionBuilder.QUESTION_TYPE.constantSum:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.ConstantSum, (0, _extends2.default)({}, question, {
            response: response || [],
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
        case _questionBuilder.QUESTION_TYPE.textField:
          view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.SingleLine, (0, _extends2.default)({}, question, {
            response: response || '',
            onResponse: function onResponse(id, resp) {
              return defaultFunction;
            },
            number: number
          }));
          break;
      }
      return view;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var cards = this.props.selectedQbItemIds.map(function (sq, index) {
        var qbItem = _this2.props.questionBankData.find(function (x) {
          return x.citrusElement.id === sq;
        });
        return /*#__PURE__*/_react.default.createElement(_card.Card, {
          className: "pcty-margin-bottom",
          header: " ",
          headerAddOn: function headerAddOn() {
            return /*#__PURE__*/_react.default.createElement(_tag.Tag, {
              value: qbItem.questionBankCategoryDescription
            });
          },
          renderActionArea: function renderActionArea() {
            return /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
              onClick: function onClick() {
                return _this2.onDeleteQuestion(sq);
              }
            }, _Icon || (_Icon = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
              name: "trash",
              title: "Delete"
            })));
          }
        }, _this2.renderQuestion(qbItem.citrusElement, index + 1));
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, cards));
    }
  }]);
  return PctyQuestionBuilderQuestionBankPreview;
}(_react.Component);
PctyQuestionBuilderQuestionBankPreview.propTypes = {
  selectedQbItemIds: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  questionBankData: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  onQuestionsChange: _propTypes.default.func.isRequired
};
var _default = exports.default = PctyQuestionBuilderQuestionBankPreview;